export default __webpack_public_path__ + "static/ios-ff4de9f50d25ac6fa323c6b09c5209c4.svg";